import { ReactNode } from 'react';
import {
  Box,
  Card,
  CircularProgress,
  Divider,
  Typography,
} from '@mui/material';
import TooltipComponent from '../TooltipComponent';

interface CardComponentProps {
  children?: ReactNode;
  title?: string | ReactNode;
  disabled?: boolean;
  onClick?: () => void;
  tooltipMessage?: string;
  representativeColor?: 'green' | 'red' | '#fff' | 'rgb(47, 57, 87)';
  additionalMessage?: string | ReactNode;
  isLoading?: boolean;
  headerAdditionalComponent?: string | ReactNode;
}

const CardComponent = ({
  children,
  title,
  disabled,
  onClick,
  tooltipMessage,
  representativeColor,
  additionalMessage,
  isLoading,
  headerAdditionalComponent,
}: CardComponentProps) => {
  const handleClick = () => {
    if (onClick && !disabled) {
      onClick();
    }
  };
  return (
    <TooltipComponent title={!disabled && tooltipMessage ? tooltipMessage : ''}>
      <Card
        onClick={handleClick}
        sx={{ padding: 2 }}
        style={{
          height: '100%',
          border: `1px solid ${representativeColor && !disabled ? representativeColor : 'rgb(47, 57, 87)'}`,
          opacity: disabled ? 0.4 : 1,
          cursor: onClick !== undefined && !disabled ? 'pointer' : 'default',
        }}
        className={onClick && !disabled ? 'card-zone' : ''}
      >
        {isLoading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <CircularProgress />
          </Box>
        ) : (
          <>
            {title && (
              <>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }}
                >
                  <Typography sx={{ fontWeight: 'bold' }}>{title}</Typography>
                  {headerAdditionalComponent}
                </Box>
                <Divider sx={{ my: 2, backgroundColor: 'rgb(47, 57, 87)' }} />
              </>
            )}
            {children}
            {additionalMessage && (
              <Typography
                fontSize={13}
                color={disabled ? '#fff' : representativeColor}
              >
                {additionalMessage}
              </Typography>
            )}
          </>
        )}
      </Card>
    </TooltipComponent>
  );
};

export default CardComponent;
